@let companyProfile = contractor()?.companyProfile ?? null;
<onyx-modal
  variant="right"
  [heading]="companyProfile?.displayName ?? ''"
  [loading]="loading()"
  [(error)]="error"
  [close$]="close$"
  (errorChange)="contractor$.next()"
  (closeModal)="dialogRef.close()"
>
  <ng-container image>
    @if (contractor(); as contractor) {
      <onyx-avatar
        variant="company"
        [company]="{ logo: undefined }"
        [size]="60"
      ></onyx-avatar>
    }
  </ng-container>

  <ng-container description>
    @if (contractor()?.companyProfile; as companyProfile) {
      <p class="description">
        {{ 'labels.vatId' | translate }}: {{ companyProfile.country | uppercase
        }}{{ companyProfile.vatId }}

        @for (type of companyProfile.types ?? []; track type) {
          ·
          {{ `${DictionaryCode.CONTRACTOR_TYPE}.${type.value}` | translate }}
        }
      </p>
    }
  </ng-container>

  <ng-container headingButtons>
    @if (contractor(); as contractor) {
      @let isActive = contractor.status.value === ContractorStatus.ACTIVE;
      @if (!isArchived()) {
        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="32"
          [circle]="true"
          (click)="isActive ? block() : unblock()"
          [onyxTooltip]="isActive ? 'labels.block' : 'labels.unblock'"
          [onyxTooltipPositions]="[OnyxOverlayPosition.BOTTOM]"
          [onyxTooltipOverridePositions]="{ panelClass: ['bottom'] }"
        >
          <onyx-icon
            [name]="isActive ? 'locked-outlined' : 'unlocked-outlined'"
            [size]="20"
          ></onyx-icon>
        </onyx-icon-button>

        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="32"
          icon="edit-outlined"
          [circle]="true"
          onyxTooltip="labels.edit"
          (click)="edit()"
        ></onyx-icon-button>
      }

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="telephone-outlined"
        [circle]="true"
        onyxTooltip="labels.call"
        (click)="ActionHelper.makeCall(companyProfile!.phone)"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="share-outlined"
        [circle]="true"
        onyxTooltip="labels.share"
        (click)="share()"
      ></onyx-icon-button>

      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="options-vertical-filled"
        [circle]="true"
        [onyxDropdownOptions]="options()"
        [onyxDropdownDisabled]="!options()?.length"
        (onyxDropdownSelectedValueChange)="$event.value?.()"
        onyxTooltip="labels.options"
        (click)="$event.stopPropagation()"
      ></onyx-icon-button>
    }
  </ng-container>

  @if (contractor(); as contractor) {
    <div class="container">
      <app-contractor-payment
        [payment]="contractor.payment"
      ></app-contractor-payment>

      <app-contractor-contacts
        [contractor]="contractor"
      ></app-contractor-contacts>

      <onyx-chips
        [chips]="sections()"
        variant="secondary"
        [single]="true"
        [gap]="8"
        [(activeValues)]="section"
      ></onyx-chips>

      @switch (section()[0]) {
        @case (ContractorModalSection.BRANCHES) {
          <app-contractor-modal-branches
            [contractor]="contractor"
            [close$]="close$"
          ></app-contractor-modal-branches>

          <!-- <div class="addresses-container">
            <div class="company-addresses">
              <onyx-information-row label="labels.mainAddress">
                <onyx-address
                  [address]="address.mainAddress"
                  format="full"
                  [showFlag]="false"
                ></onyx-address>
              </onyx-information-row>

              @let correspondenceAddress = address.correspondenceAddress;
              @if (correspondenceAddress) {
                <onyx-information-row label="labels.correspondenceAddress">
                  <onyx-address
                    [address]="correspondenceAddress"
                    format="full"
                    [showFlag]="false"
                  ></onyx-address>
                </onyx-information-row>
              }

              @let branches = contractor.branches;
              @if (branches) {
                @for (branch of branches; track branch.name) {
                  <onyx-information-row label="labels.branch">
                    <div class="branch">
                      <p>{{ branch.name }}</p>

                      <onyx-address
                        [address]="branch.addresses.correspondenceAddress"
                        format="full"
                        [showFlag]="false"
                      ></onyx-address>
                    </div>
                  </onyx-information-row>
                }
              }
            </div>

            <onyx-map></onyx-map>
          </div> -->
        }

        @case (ContractorModalSection.POINTS_OF_INTEREST) {
          <app-contractor-modal-points-of-interest
            [contractor]="contractor"
          ></app-contractor-modal-points-of-interest>
        }

        @case (ContractorModalSection.DOCUMENTS) {
          <onyx-table
            [data]="contractor.documents"
            [columns]="COLUMNS"
            [rowSize]="48"
            [tableShadow]="false"
          ></onyx-table>
        }

        @case (ContractorModalSection.COMPANY) {
          <onyx-information-row label="labels.companyName">
            {{ companyProfile!.companyName }}
          </onyx-information-row>
        }
      }
    </div>
  }
</onyx-modal>
